'use client'

import Pagination from '@component/pagination'
import { useCallback, useMemo } from 'react'
import useAgentListContext from '../context'
import useProgressRouter from '@hooks/useProgressRouter'
import getAgentRoute from '@plugin/searchRoute/modules/agent'
import { agentList } from '@router'
import { usePathname, useSearchParams } from 'next/navigation'
import { get, join, replace } from 'lodash-es'

export default function AgentSearchPagination() {

  const { slug, pageSize, totals, suburbs, searchType, filter } = useAgentListContext()
  const pageIndex = useMemo(() => {
    const agentRoute = getAgentRoute()
    agentRoute.fromSlug(slug)
    return agentRoute.page || 1
  }, [slug])

  const { replaceRouter } = useProgressRouter()
  const changeHandle = useCallback(idx => {
    const agentRoute = getAgentRoute()
    agentRoute.fromSlug(slug)
    agentRoute.clearSuburbs()
    agentRoute.setSuburbs(suburbs)
    agentRoute.page = idx
    const newSlug = agentRoute.toSlug()
    replaceRouter(agentList(get(searchType, 'route'), newSlug, filter))
  }, [suburbs, slug, filter, searchType, replaceRouter])

  const pathname = usePathname()
  const searchParams = useSearchParams()
  const paginationUrl = useMemo(() => {
    let urlpath
    if (/page_/.test(pathname)) {
      urlpath = replace(pathname, /page_\d+/, 'page_{page}')
    } else {
      urlpath = join([pathname, 'page_{page}'], '_')
    }
    const query = searchParams.toString()
    return query ? join([urlpath, query], '?') : urlpath
  }, [pathname, searchParams])

  return totals > 0 && (
    <Pagination pageIndex={pageIndex} center preload pageSize={pageSize} totals={totals} onChange={changeHandle} url={paginationUrl} className='mt-30 sm:mt-48'></Pagination>
  )
}
